
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import { addCurrencyUnit, addCurrencySymbol } from "@common/src/utils/tools";
import { InjectFunction } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";
import { formDownload } from "@common/src/utils/tools";
import TextTips from "@common/src/components/scope/text-tips/index.vue";

import { getDateRange } from "@common/src/utils/common";
const partsCategory = namespace("parts-category");
const common_statement = namespace("common_statement");
const parts = namespace("parts");
@InjectFunction("emptyToLine", "splitThousands", "getTest")
@Component({ components: { TextTips } })
@Table("loadListData")
export default class Invoicing extends Vue {
  @partsCategory.Action getCategoryList;
  @common_statement.Action queryInvoicing;
  @parts.Action getPartsBrandList;
  t = t;
  searchForm = {
    categoryCode: "",
    partsName: "",
    beginTime: "",
    endTime: ""
  };
  hideCost: boolean = true;
  addCurrencyUnit = addCurrencyUnit;
  addCurrencySymbol = addCurrencySymbol;
  sortForm: {};
  dataList: any[] = [];
  choiceDate = "";
  get searchList() {
    return [
      {
        label: t("v210831.time-frame"),
        value: [this.searchForm.beginTime, this.searchForm.endTime],
        resetValue: this.getDefaultDate(),
        type: "daterange",
        prop: "paidTime",
        required: true,
        disabledFuture: true,
        maxDay: 90,
        endOffset: -1
      },
      {
        label: t("parts.name"),
        type: "input",
        value: "",
        prop: "partsName"
      },
      {
        label: t("parts.code"),
        type: "input",
        value: "",
        prop: "partsNumber"
      },
      {
        label: t("parts.category"),
        type: "cascader",
        prop: "categoryCode",
        value: "",
        options: this.categoryList,
        props: {
          label: "categoryName",
          value: "categoryCode"
        }
      },
      {
        label: t("setting.brand"),
        type: "select",
        selectList: this.brandList,
        value: "",
        prop: "brandCode"
      },
      {
        label: t("parts.specifications"),
        type: "input",
        value: "",
        prop: "specification"
      }
    ];
  }
  categoryList: any = [];
  created() {
    this.init();
  }
  mounted() {}
  async init() {
    // this.loadListData();
    this.initTime();
    this.handleSearch(this.searchList);
    this.getBrandList();
    const data = await this.getCategoryList();
    this.categoryList = this.addLeafFlag(this.$safeValue(data, "data", []));
  }
  listData: any = {};
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryInvoicing({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
      // partsName: this.searchForm.partsName
    }).then(data => {
      this.dataList = this.$safeValue(data, "data.list", []);
      this.listData = this.$safeValue(data, "data", {});
      return data;
    });
  }

  initTime() {
    [this.searchForm.beginTime, this.searchForm.endTime] = this.getDefaultDate();
  }
  addLeafFlag(list) {
    if (!list) return;
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "categoryCode") {
          this.searchForm[item.prop] = item.value[item.value.length - 1] || "";
        } else if (item.prop === "paidTime") {
          this.searchForm.beginTime = item.value ? item.value[0] : "";
          this.searchForm.endTime = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  brandList: any = [];
  getBrandList() {
    this.getPartsBrandList().then(data => {
      this.brandList = this.$safeValue(data, "data.list", []).map(item => ({
        label: item.brandName,
        value: item.brandCode
      }));
    });
  }
  handleExportData() {
    let data = this.searchList;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "categoryCode") {
          this.searchForm[item.prop] = item.value[item.value.length - 1] || "";
        } else if (item.prop === "paidTime") {
          this.searchForm.beginTime = item.value ? item.value[0] : "";
          this.searchForm.endTime = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    formDownload(`${window.API_URL}/psi/queryPsi/export`, this.searchForm);
  }
  formatNumber(data, type) {
    let num = "0";
    if (typeof data === "number") {
      if (data > 0 && type == 1) {
        num = "+" + data;
      } else if (data > 0 && type == 2) {
        num = "-" + data;
      } else {
        num = data + "";
      }
    }
    return num;
  }
  judgeNumColor(data, type) {
    let color = "";
    if (typeof data === "number") {
      if (data > 0 && type == 1) {
        color = "font-green";
      } else if (data > 0 && type == 2) {
        color = "font-red";
      }
    }
    return color;
  }
  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/setting/parts-edit/${row.partsCode}`
    });
    window.open(href, "_blank");
  }
  getDefaultDate(): Array<string> {
    return getDateRange("first_day_to_yesterday_of_current_month", "YYYYMMDD");
  }
}
